require('./bootstrap');
import { createApp, h } from 'vue';
import { createRouter, createMemoryHistory } from 'vue-router';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import { ZiggyService } from './Plugins/ziggy';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import { GoogleMapsService } from './Plugins/google-maps';
import { SpinnerService } from './Plugins/spinner';
import { ToastServicePlugin } from './Plugins/toast-service';
import ConfirmationService from 'primevue/confirmationservice';
import { i18nVue, isLoaded as isLoaleLoaded } from 'laravel-vue-i18n';
import { AxiosPlugin } from './Plugins/axios';
import { PagePropsPlugin } from './Plugins/page-props';
import { MittService } from './Plugins/mitt';
import primevueLocale from './primevue-config-it';
const route = window.route;
const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';
let startInterval;
let gmapReady = false;
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        const VueApp = createApp({ render: () => h(app, props) })
            .use(plugin)
            .use(PrimeVue)
            .use(ToastService)
            .use(ConfirmationService)
            .use(ZiggyService)
            .use(createRouter({
            routes: [],
            history: createMemoryHistory(),
        }))
            .use(VueGoogleMaps, {
            load: {
                key: process.env.MIX_GOOGLE_MAPS_API_KEY,
                libraries: 'places',
            },
            autobindAllEvents: true,
        })
            .use(ToastServicePlugin)
            .use(AxiosPlugin)
            .use(SpinnerService)
            .use(MittService)
            .use(i18nVue, {
            resolve: (lang) => import(`../lang/${lang}.json`),
        })
            .use(PagePropsPlugin)
            .mixin({ methods: { route } });
        VueApp.config.globalProperties.$locale =
            document.documentElement.getAttribute('lang') ?? 'it';
        VueApp.config.globalProperties.$primevue.config.locale = primevueLocale;
        VueApp.config.globalProperties.primevueDataTableDefaults = {
            paginator: true,
            rows: 10,
            rowHover: true,
            paginatorTemplate: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
            rowsPerPageOptions: [10, 25, 50],
            currentPageReportTemplate: '{first} - {last} di {totalRecords} elementi',
            responsiveLayout: 'stack',
            breakpoint: '1180px',
        };
        /** Google Maps */
        VueApp.$gmapApiPromiseLazy().then(() => {
            VueApp.use(GoogleMapsService);
            gmapReady = true;
        });
        // Wait for all needed components to load then mount
        startInterval = setInterval(() => {
            if (gmapReady &&
                isLoaleLoaded(VueApp.config.globalProperties.$locale)) {
                clearInterval(startInterval);
                VueApp.mount(el);
            }
        }, 500);
    },
});
InertiaProgress.init({ color: '#4B5563' });
